import React, { Component } from "react";
import BackgroundSlider from 'react-background-slider'

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";

import image1 from '../../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-1.jpg'
import image2 from '../../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-2.jpg'
import image3 from '../../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-3.jpg'
import image4 from '../../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-4.jpg'
import image5 from '../../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-5.jpg'
import image6 from '../../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-6.jpg'


class Temperatura extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-8">			
                        <h2>Itech<span class="azul">Flow</span></h2>
                        <h3>Solução de Monitoramento de Temperatura e Umidade</h3>
                        <span class="saude">Saúde</span> <span class="varejo">Varejo</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-6">
                        {/* <div id="galeria" class="owl-carousel">
                            <img src={"../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-1.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                            <img src={"../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-2.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                            <img src={"../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-3.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                            <img src={"../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-4.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                            <img src={"../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-5.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                            <img src={"../assets/img/solucoes/img-solucoes_monitoramento-de-temperatura-6.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          </div> */}
                          <div style={{width: '480px', height: '400px'}} class="img-fluid m-auto" >
                              <BackgroundSlider
                                  images={[image1, image2, image3, image4, image5, image6]}
                                  duration={5}
                                  transition={0.5}
                              />
                              {/* <img src={image1} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img> */}
                          </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <h3>Solução:</h3>
                        {/* <p><b>Monitoramento on-line de geladeiras de medicamentos</b> de alto custo nas farmácias com envio de mensagens proativas em caso de falha, sem necessidade da rotineira inspeção manual.</p> */}
                          <p><b>Monitoramento on-line e preventivo de temperatura e umidade,</b> através de gestão a vista e envio de mensagens proativas em caso de falhas, sem necessidade da rotineira inspeção manual.</p>
                        <h3>Descrição:</h3>
                        <p>Nossa solução foi desenvolvida com o objetivo de assegurar melhor monitoramento das variações de temperatura e umidade em câmaras frias, geladeiras, salas e compartimentos que armazenam produtos controlados e que não podem ficar expostos a variações de temperatura e umidade fora dos limites pré-determinados.</p>
                      </div>


                      <div class="col-12 mt-5">
                        <h3>Aplicação:</h3>
                        <p>Ambientes internos (indoor) e Ambientes externos (outdoor), ambientes que requerem controle de temperatura e umidade, compartimentos refrigerados e não refrigerados.</p> 
                        
                        <h3>Principais funcionalidades e benefícios:</h3>
                      </div>

                      <div class="col-12 col-md-6">
                        <ul>
                          <li>Monitoramento em tempo real de temperatura e umidade via WEB.</li>
                          <li>Alertas de variações acima e abaixo do limite permitido via Telegram, Whats app, email, SMS, etc..;</li>
                          <li>Controle através de Dash-board intuitivo.</li>
                          <li>Acionamento automático da Manutenção preventiva;</li>
                          <li>Prevenção de perda de produtos por paradas dos equipamentos;</li>
                          <li>Programa ItechMed de calibração preventiva dos termômetros</li>
                          <li>Certificado de calibração <span class="text-danger">*</span></li>
                          <li>Redução de erros nos registros e coletas manuais de informações;</li>
                        </ul>
                      </div>

                      <div class="col-12 col-md-6">
                        <ul>
                          <li>Range de medição de temperatura -30ºC / +60ºC</li>
                          <li>Atende Norma RDC-430/2022 da ANVISA</li>
                          <li>Permite análise gráfica do comportamento de funcionamento das geladeiras</li>
                          <li>Relatórios de monitoramento a cada hora e diário, podendo ser assinado digitalmente pelo celular.</li>
                          <li>Armazenamento de informações em nuvem;</li>
                          <li>SW desenvolvido Web-based (Não requer APP)</li>

                        </ul>

                        <br></br><br></br>
                      </div>

                      <div class="col-12 text-center" >
                          <a href={"../pdf/catalogo-temperatura.pdf"} class="btn-itm" target="_blank">Baixar Catálogo</a>
                          <br></br><br></br>
                      </div>
                    </div>
                  </div>
                </section>
            
                <Devsolucoes></Devsolucoes>
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Temperatura;